import { getPageQuery } from '@/libs/app';
import { ReducerType, ReducerTypes, CategoryDefault } from '@/features/products/list/const';
import console from 'console';

export const initialState = {
  limit: 20,
  offset: 0,
  color: '',
  gem_type: '',
  gem_pure: '',
  gem_material: '',
  product_keyword: '',
  jewelry_material: '',
  cat_code: CategoryDefault,
  price: '',
  tags: '',
  quotation: '',
  sort_by: '',
};

export type ActionType =
  | { type: ReducerType.OnFilterReset }
  | { type: ReducerType.OnPageChange; payload: number }
  | { type: ReducerType.OnColorChange; payload: string }
  | { type: ReducerType.OnKeywordChange; payload: string }
  | { type: ReducerType.OnCategoryChange; payload: string }
  | { type: ReducerType.OnGemTypeChange; payload: string }
  | { type: ReducerType.OnGemPureChange; payload: string }
  | { type: ReducerType.OnGemMaterialChange; payload: string }
  | { type: ReducerType.OnJewelryMaterialChange; payload: string }
  | { type: ReducerType.OnPriceChange; payload: string }
  | { type: ReducerType.OnTagChange; payload: string }
  | { type: ReducerType.OnQuotationChange; payload: string }
  | { type: ReducerType.OnSortBy; payload: string }
  | { type: ReducerType.OnAllChange; payload: any };

export const reducer = (state: ReducerTypes, action: ActionType): ReducerTypes => {
  switch (action.type) {
    case ReducerType.OnPageChange:
      return {
        ...state,
        offset: getPageQuery(action.payload, initialState.limit),
      };

    case ReducerType.OnColorChange:
      return {
        ...state,
        color: action.payload,
      };

    case ReducerType.OnGemTypeChange:
      return {
        ...state,
        gem_type: action.payload,
      };

    case ReducerType.OnGemPureChange:
      return {
        ...state,
        gem_pure: action.payload,
      };

    case ReducerType.OnGemMaterialChange:
      return {
        ...state,
        gem_material: action.payload,
      };

    case ReducerType.OnJewelryMaterialChange:
      return {
        ...state,
        jewelry_material: action.payload,
      };

    case ReducerType.OnKeywordChange:
      return {
        ...state,
        product_keyword: action.payload,
      };

    case ReducerType.OnCategoryChange:
      return {
        ...state,
        cat_code: action.payload,
      };
    case ReducerType.OnAllChange:
      return {
        ...state,
        ...action.payload,
      };
    case ReducerType.OnPriceChange:
      return {
        ...state,
        price: action.payload,
      };
    case ReducerType.OnQuotationChange:
      return {
        ...state,
        quotation: action.payload,
      };
    case ReducerType.OnTagChange:
      return {
        ...state,
        tags: action.payload,
      };
    case ReducerType.OnSortBy:
      return {
        ...state,
        sort_by: action.payload,
      };
    case ReducerType.OnFilterReset:
      return {
        ...state,
        limit: 20,
        offset: 0,
        color: '',
        gem_type: '',
        gem_pure: '',
        gem_material: '',
        product_keyword: '',
        jewelry_material: '',
        price: '',
        sort_by: '',
        tags: '',
      };
    default:
      return { ...initialState };
  }
};
